import { Observable } from 'rxjs';
import { RestCallBuilder } from '../../../builder/rest/rest-call.builder';
import { API_RESPONSE_SCHEMA, IApiResponse } from '@web/shared-types';
import {
  IOnDemandAvailabilityRequest,
  IOnDemandAvailabilityResponse,
  IOnDemandBookingRequest,
  IOnDemandBookingResponse,
  ON_DEMAND_AVAILABILITY_RESPONSE_SCHEMA,
  ON_DEMAND_BOOKING_RESPONSE_SCHEMA,
} from '@web/dtos';
import { AppConfigService } from '../../app-config.service';
import { inject } from '@angular/core';

export class OnDemandAvailabilityGateway {
  private readonly configService: AppConfigService = inject(AppConfigService);
  private readonly availabilityBuilder: RestCallBuilder<
    IOnDemandAvailabilityRequest,
    IOnDemandAvailabilityResponse
  > = new RestCallBuilder<
    IOnDemandAvailabilityRequest,
    IOnDemandAvailabilityResponse
  >({ isAvailable: false, connectionOptions: [] });

  private readonly bookingBuilder: RestCallBuilder<
    IOnDemandBookingRequest,
    IOnDemandBookingResponse
  > = new RestCallBuilder<IOnDemandBookingRequest, IOnDemandBookingResponse>({
    bookingRef: '',
    systemRef: '',
  });

  private get efaUrl(): string {
    return this.configService.get().general.efaUrl;
  }

  checkAvailability(
    req: IOnDemandAvailabilityRequest
  ): Observable<IApiResponse<IOnDemandAvailabilityResponse>> {
    return this.availabilityBuilder
      .postExternal(`${this.efaUrl}/on-demand/availability`, req)
      .validate(
        API_RESPONSE_SCHEMA(ON_DEMAND_AVAILABILITY_RESPONSE_SCHEMA),
        'OnDemandAvailabilityGateway.checkAvailability'
      )
      .handleMessages()
      .build();
  }

  reserve(
    req: IOnDemandBookingRequest
  ): Observable<IApiResponse<IOnDemandBookingResponse>> {
    return this.bookingBuilder
      .postExternal(`${this.efaUrl}/on-demand/reserve`, req)
      .validate(
        API_RESPONSE_SCHEMA(ON_DEMAND_BOOKING_RESPONSE_SCHEMA),
        'OnDemandAvailabilityGateway.reserve'
      )
      .handleMessages()
      .build();
  }
}
